import { memo } from 'react'
import { Loader } from 'shared/ui'

import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import SentimentIcon from '@groovehq/internal-design-system/lib/assets/icons/Sentiment'

import { styles as baseStyles } from '../styles'

const Sentiment = ({ suggestion, isLoading }) => {
  if (!suggestion.id && !isLoading) {
    return null
  }

  return (
    <div className="grui flex flex-col mb-10">
      <span css={baseStyles.actionTitle}>Sentiment</span>

      {isLoading ? (
        <Loader className="grui my-7" />
      ) : (
        <div className="grui flex mt-5">
          <Tooltip
            title="Negative"
            position="top"
            strategy="fixed"
            disabled={suggestion.value !== '-1'}
          >
            <span className="grui flex">
              <SentimentIcon
                sentiment={-1}
                active={suggestion.value === '-1'}
              />
            </span>
          </Tooltip>

          <Tooltip
            title="Neutral"
            position="top"
            strategy="fixed"
            disabled={suggestion.value !== '0'}
          >
            <span className="grui flex ml-4">
              <SentimentIcon sentiment={0} active={suggestion.value === '0'} />
            </span>
          </Tooltip>

          <Tooltip
            title="Positive"
            position="top"
            strategy="fixed"
            disabled={suggestion.value !== '1'}
          >
            <span className="grui flex ml-4">
              <SentimentIcon sentiment={1} active={suggestion.value === '1'} />
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default memo(Sentiment)
